import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-type-date",
  "use": "icon-type-date-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-type-date\"><path d=\"M13 2h-1V1h-1v1H4.5V1h-1v1H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2M3 3h.5v1h1V3H11v1h1V3h1c.552 0 1 .449 1 1v1H2V4c0-.551.449-1 1-1m10 10H3c-.551 0-1-.448-1-1V6h12v6a1 1 0 0 1-1 1\" /><path d=\"M4 7h1.5v1H4zm3.25 0h1.5v1h-1.5zm3.25 0H12v1h-1.5zM4 9h1.5v1H4zm3.25 0h1.5v1h-1.5zm3.25 0H12v1h-1.5zM4 11h1.5v1H4zm3.25 0h1.5v1h-1.5zm3.25 0H12v1h-1.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol